// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__qAXVY","city":"styles_city__3P68k","company":"styles_company__CWlqN","dates":"styles_dates__ND1Hn","description":"styles_description__YMQEj"};